const Tricolor = ({ className = "" }) => (
  <div className={`flex items-center gap-1.5 ${className}`} aria-hidden="true" data-testid="tricolor-bars">
    <span className="h-[3px] w-12 rounded-full bg-[#009246]" />
    <span className="h-[3px] w-12 rounded-full bg-[#D9D9D6]" />
    <span className="h-[3px] w-12 rounded-full bg-[#E30613]" />
  </div>
);

export default Tricolor;
